import React from 'react';
import bankone from '../Images/bankone.jpeg';
import banktwo from '../Images/banktwo.jpeg';
import bankthree from '../Images/bankthree.jpeg';
import nithi from '../Images/nithi.jpeg'
import veg from '../Images/veg.jpeg'

function GetTouch() {
    const services = [
        {
            title: 'Neethi Medical Store',
            desc: 'We operate Neethi Medical Stores to provide affordable healthcare. These outlets offer essential medicines at discounted prices, making healthcare accessible to the community. Current location: Cheroor. Additional facility: Fertilizer Depot.'
        },
        {
            title: 'Organic Vegetable Store',
            desc: 'We run an Organic Vegetable Store that provides fresh, pesticide-free vegetables at subsidized rates. This initiative supports local farmers and promotes healthy living in the community.'
        },
        {
            title: 'Business Correspondent Services',
            desc: 'To reach remote villages, we’ve appointed Business Correspondents (BCs) who assist with new accounts, deposits, loans, and secure thumb/e-signature transactions using mobile devices.'
        }
    ];

    const storeImages = [bankone, banktwo, nithi,veg];

    return (
        <div className='py-5' style={{ backgroundColor: '#f7f9fc' }}>
            <div className='container'>

                <div className='row g-4 align-items-start flex-column-reverse flex-md-row'>
                    {/* Left Side - Cards */}
                    <div className='col-md-6'>
                        {services.map((item, index) => (
                            <div key={index} className="card mb-4 shadow-sm border-0 rounded-4">
                                <div className="card-body">
                                    <h5 className="card-title text-danger">{item.title}</h5>
                                    <p className="card-text">{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Right Side - Images */}
                    <div className='col-md-6'>
                        <h4 className="text-center text-danger mb-4">Our Stores</h4>
                        <div className="row g-2">
                            {storeImages.map((img, idx) => (
                                <div className="col-6" key={idx}>
                                    <img
                                        src={img}
                                        alt={`store-${idx}`}
                                        className="img-fluid rounded-3 shadow-sm"
                                        style={{ height: '150px', objectFit: 'cover', width: '100%' }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    );
}

export default GetTouch;
